<template>
    <div class="bg-blue">
        <div class="product-wrapper">
            <div class="frame">
                <h2 class="main-title">
                    酵出自然的美齒
                </h2>
                <p class="main-subtitle">
                    2020  CP值最高的學習
                </p>
                <div class="toothpaste-wrapper">
                    <div class="left">
                        <img src="@/assets/product_toothpaste_01.png"
                        alt="酵素淨護牙膏1.5倍氟素防蛀" class="img">
                        <p class="title">酵素淨護牙膏</p>
                    </div>
                    <div class="right">
                        <img src="@/assets/product_toothpaste_02.png"
                        alt="酵素亮白系列珍珠光去漬亮白" class="img">
                        <p class="title">酵素亮白系列</p>
                    </div>
                </div>
                <p class="panel-wrapper blue">
                    固齒佳嚴選日本在地多種植物與水果發酵萃取精製酵素，更為日本厚生省（等同於台灣衛生署）唯一認證有效齒垢分解酵素。
                    能夠高效分解飲食後口腔所凝聚的牙菌斑，幫助去除牙漬，避免牙結石的生成。
                    <span class="adorn adorn1"></span>
                </p>
                <div class="toothpaste-intro">
                    <div class="top">
                        <div class="w55">
                            <img src="@/assets/product_toothpaste_03.png" alt="酵素淨護牙膏" class="img">
                        </div>
                        <div class="w45">
                            <h3 class="title">酵素<br>淨護牙膏</h3>
                            <p class="subtitle">130 g</p>
                            <span class="tag tag1">清涼薄荷</span>
                            <span class="tag tag2">柑橘薄荷</span>
                        </div>
                    </div>
                    <div class="middle">
                        <p class="circle circle1">
                            酵素<br>潔牙
                        </p>
                        <p class="circle circle2">
                            強化<br>琺瑯質
                        </p>
                        <p class="circle circle3">
                            預防<br>牙結石
                        </p>
                    </div>
                    <div class="bottom">
                        <ol class="panel-wrapper white">
                            <li>
                                <p class="title">日本植萃酵素配方</p>
                                <p class="info">日本厚生省唯一認證齒垢分解酵素</p>
                            </li>
                            <li>
                                <p class="title">高濃度1.5倍含氟量</p>
                                <p class="info">高濃度氟素結合高密著科技，存留於齒面、強化琺瑯質並預防蛀牙</p>
                            </li>
                            <li>
                                <p class="title">TPP防護因子</p>
                                <p class="info">預防齒垢堆積，形成牙結石</p>
                            </li>
                            <li>
                                <p class="title">LSS淨徹成分</p>
                                <p class="info">持續清新口氣，幫助去除引起蛀牙、口臭細菌</p>
                            </li>
                        </ol>
                        <span class="adorn adorn2"></span>
                    </div>
                </div>
                <div class="toothpaste-intro">
                    <div class="top">
                        <div class="w45">
                            <h3 class="title">酵素<br>亮白牙膏</h3>
                            <p class="subtitle">130 g</p>
                            <span class="tag tag3">百花薄荷</span>
                            <span class="tag tag4">柑橘薄荷</span>
                        </div>
                        <div class="w55">
                            <img src="@/assets/product_toothpaste_04.png" alt="酵素淨護牙膏" class="img">
                        </div>
                    </div>
                    <div class="middle gray">
                        <p class="circle circle4">
                            酵素<br>亮白
                        </p>
                        <p class="circle circle5">
                            抑漬<br>保護層
                        </p>
                        <p class="circle circle6">
                            修護<br>琺瑯質
                        </p>
                    </div>
                    <div class="bottom">
                        <ol class="panel-wrapper white">
                            <li>
                                <p class="title">日本植萃酵素配方</p>
                                <p class="info">日本厚生省唯一認證齒垢分解酵素</p>
                            </li>
                            <li>
                                <p class="title">獨特抑漬保護層</p>
                                <p class="info">能夠形成屏障幫助預防外源性色斑附著</p>
                            </li>
                            <li>
                                <p class="title">高密度氟素</p>
                                <p class="info">修護琺瑯質細微損傷，讓牙漬不易堆積</p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-smile ad">
            <div class="container product-wrapper">
                <div class="frame">
                    <div class="ad-wrapper">
                        <span class="adorn adorn3"></span>
                        <h3 class="title">
                            照顧好牙齒就是<br>最有酵的投資！
                        </h3>
                        <p class="subtitle">
                            日本累積銷售超過10億支，
                            有「予防歯科」之稱的固齒佳
                            及早預存您的健康齒本
                        </p>
                        <div class="btn-wrapper">
                            <div class="note">↓大好評発売中，立即購入↓</div>
                            <button type="button" class="btn btn-shop"
                            @click="goPage('http://bit.ly/2FyF7qW'); gaEvent('products_btn', 'LION_EC');">
                            <img src="@/assets/product_shop_logo.png" alt="">
                            </button>
                        </div>
                        <span class="adorn adorn4"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'Product',
    methods: {
        goPage(url) {
            window.open(url, '_blank');
        },
    },
    mixins: [mixinMethod],
};
</script>
